export enum ContentControlledMediaTypeEnum {
  None = 0,
  External = 1,
  Video,
  Audio,
  Subtitles,
  Graphics,
  Inclusive = 100,
}
